import { createURLParser } from '../../../util/index';
import { Request } from '../../models/index';
import { GetAccessToken } from '../oauth/GetAccessToken';
import { UseCase } from '../UseCase';
import moment from 'moment';

export class CreateRequest<T> implements UseCase<Request<T>, Request<T>> {
    private getAccessToken = new GetAccessToken();

    execute<T>(request: Request<T>): Request<T> {
        if (request.search) {
            const parser = createURLParser(request.url);
            parser.search = '';
            request.url = parser.href;
        }

        request.method = request.method || 'GET';
        request.headers = request.headers || {};
        request.headers['UTC-Offset'] = moment().format('Z'); // "+01:00"

        request.headers['Content-Type'] = 'application/vnd.mdd.portal-v1.0.0+json';
        const access = this.getAccessToken.execute();
        if (access) {
            request.headers.Authorization = `Bearer ${access.token}`;
        }

        return request;
    }
}
